<template>
    <div :class="styleClass" itemscope itemtype="https://schema.org/NewsArticle">
        <a href="#"
           :data-teaser="teaser.data" :data-id="teaser.teaser_id" :data-index="teaser.index" :data-position="teaser.position" 
           @click.prevent="click" class="item item-sec-row" :style="style" itemprop="url">


            <div class="card_col_1">                
                <img :src="teaser.path_rectangle_image" ref="img" class="card-img" v-bind="crossorigin" itemprop="image" >		
            </div>
            <div class="card-img-out">
                <h5 class="card-title" itemprop="name">{{teaser.title}}</h5>
                <div class="card-description" v-if="teaser.description && teaser.description.length > 0">{{teaser.description}}</div>
                <div class="item__gradient" :style="gradientStyle"></div>
            </div>

        </a>
    </div>

</template>

<script>
    import FastAverageColor from 'fast-average-color';
    export default {
        name: "teaser2",
        props:{
            styleClass:String,
            teaser:Object,
            square:{
                type:Boolean,
                default:false,
            },
            position:{
                type:Number,
                default:0,
            },
        },
        data() {
            return {
                gradientStyle:{},
                style:{},
                size: 50,
            };
        },
        mounted() {
            // window.fac();

            this.style = {
                background: 'rgb(17, 12, 9)',
                color:      'white',
            };

            this.gradientStyle  = {background: 'radial-gradient(100% 500% at 100% center, rgba(17, 12, 9, 0) 55%, rgb(17, 12, 9) 75%)'};

          
                
            let img = this.$refs.img;
            // img.crossorigin = '';
            let vue = this;
            
            const imageLoadingTimeStart = performance.now();
            
            img.addEventListener('load', function() {
				vue.getTeaserImageSpeed(imageLoadingTimeStart);

                window.onscroll = (e) => {
                    try {
                        let teasers = document.querySelectorAll(".d-flex");
                        teasers.forEach(function(item) {
                            let teaser = item.querySelector(".item");

                            if(teaser.classList.contains("item-sec-row") && teaser.querySelector(".card-title").innerText.length > 80){
                                teaser.querySelector(".card-title").style.fontSize = "1.2em";
                            }
                        });
                    } catch (o) {}
                };

				if (vue.teaser.is_rtb === 1) return;

                let height = this.naturalHeight;
                let color;
                if (!window.teasersColor[img.src]) {
                    let fac = new FastAverageColor();
                    color = fac.getColor(this, {top: height - vue.size, height: vue.size});

                    window.teasersColor[img.src] = color;
                } else {
                    color = window.teasersColor[img.src];
                }

                if (color.value) {
                    var colorEnd = [].concat(color.value.slice(0, 3), 0).join(',');
                    vue.style = {
                        background: color.rgb,
                        color:      color.isDark ? 'white' : 'black',
                    };

                    vue.gradientStyle  = {background: 'radial-gradient(100% 500% at 100%, ' +
                            'rgba(' + colorEnd + ') 55%, ' + color.rgba + ' 75%)'};
                }

            }, false)
            
        },
        methods:{
            click(){
//                 this.teaser.position = this.position;
                this.Helper.adClick(this, this.teaser);
            },
            getTeaserImageSpeed(imageLoadingTimeStart) {
                if (imageLoadingTimeStart) {                 
                    const imageLoadingTimeEnd = performance.now();

                    const imageLoadingTime = imageLoadingTimeEnd - imageLoadingTimeStart;
                    const imageLoadingInfo = { 
                        url: this.$refs.img.src, 
                        time: imageLoadingTime / 1000,
                        country: window.config.country
                    };
                    
                    
                    if (!window.teasersMediaLoadingSpeeds) {
                        window.teasersMediaLoadingSpeeds = [];
                    }
                    
                    if (window.teasersMediaLoadingSpeeds && Array.isArray(window.teasersMediaLoadingSpeeds)) {
                        let existingTeaserMediaLoadingSpeed = window.teasersMediaLoadingSpeeds.find(item => item.url === imageLoadingInfo.url);

                        if (existingTeaserMediaLoadingSpeed) {
                            if (imageLoadingInfo.time < existingTeaserMediaLoadingSpeed.time) {
                                existingTeaserMediaLoadingSpeed.time = imageLoadingInfo.time;
                            }
                        } else {
                            window.teasersMediaLoadingSpeeds.push(imageLoadingInfo);
                        }
                    }    
                }
            }
        },
        computed: {
             crossorigin(){
              
               if (this.teaser.is_rtb == 0) {
                   return {crossorigin:'anonymous'};
               }

                return {};
            }
        },
        watch: {
            'teaser.path_rectangle_image'(newVal, oldVal) {
                if (typeof newVal === 'string') {
                    const imageLoadingTimeStart = performance.now();
                    
                    this.$refs.img.addEventListener('load', () => {
                        this.getTeaserImageSpeed(imageLoadingTimeStart);
                    })
                }
    		}
        }
    }
</script>

<style scoped>

</style>